import { useEffect, useState } from 'react'
import { useMap } from '@vis.gl/react-google-maps'
import {
  appMapBoundsToSuperclusterBbox,
  googleBoundsToAppMapBounds,
  type AppMapBounds,
} from './mapBounds'

export type GoogleMapViewport = {
  appBounds: AppMapBounds
  bbox: [number, number, number, number]
  rawZoom: number
  zoom: number
}

export function useGoogleMapViewport() {
  const map = useMap()
  const [viewport, setViewport] = useState<GoogleMapViewport | null>(null)

  useEffect(() => {
    if (!map) return

    const syncViewport = () => {
      const appBounds = googleBoundsToAppMapBounds(map.getBounds())
      if (!appBounds) return

      const rawZoom = map.getZoom() ?? 0

      setViewport({
        appBounds,
        bbox: appMapBoundsToSuperclusterBbox(appBounds),
        rawZoom,
        zoom: Math.floor(rawZoom),
      })
    }

    syncViewport()

    const idleListener = map.addListener('idle', syncViewport)

    return () => {
      idleListener.remove()
    }
  }, [map])

  return viewport
}
